const PAGINATION_PARAM_NAMES = {
  CATEGORY: 'kategori',
  SORT_BY: 'siralama',
  PAGE: 'sayfa',
  QUERY: 'q',
};

const PAGE_LIMIT_FOR_LOAD_MORE = 4;
const LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE = 24;

export {
  LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE,
  PAGE_LIMIT_FOR_LOAD_MORE,
  PAGINATION_PARAM_NAMES,
};
